import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';



// OTHER MODULE IMPORTS

import { SharedModule } from '../../shared.module';
import { MaterialsModule } from '../../materials.module';
import { MainPortfolioRoutingModule } from './main-portfolio-routing.module';


// IMPORT PORTFOLIO MODULE COMPONENTS
import { MainPortfolioComponent } from './main-portfolio.component';
import { AddSessionModalComponent } from '../add-session-modal/add-session-modal.component';
import { SessionsComponent } from '../sessions/sessions.component';
import { EvidencesComponent } from '../evidences/evidences.component';
import { PortfolioStatusComponent } from '../portfolio-status/portfolio-status.component';
import { ConfirmStatusComponent } from '../portfolio-status/confirm-status/confirm-status.component';
import { PortfolioAssessmentPlanComponent } from '../portfolio-assessment-plan/portfolio-assessment-plan.component';
import { PerformanceAssessmentPlanComponent } from '../performance-assessment-plan/performance-assessment-plan.component';
import { AssessmentPlanComponent } from '../assessment-plan/assessment-plan.component';
import { AchievementSummarySheetComponent } from '../achievement-summary-sheet/achievement-summary-sheet.component';
import { EalMasterPortfolioComponent } from '../eal-master-portfolio/eal-master-portfolio.component';
import { MasterRailL2Form1Component } from '../master-rail-l2-form1/master-rail-l2-form1.component';
import { ObservationTableComponent } from '../observation-table/observation-table.component';
import { LearnerVideoObservationComponent } from '../learner-video-observation/learner-video-observation.component';
import { SpecimenSignatureComponent } from '../specimen-signature/specimen-signature.component';
import { InfoNContactComponent } from '../info-ncontact/info-ncontact.component';
import { PdePolicyComponent } from '../pde-policy/pde-policy.component';
import { CustomerServiceEnvironmentComponent } from '../customer-service-environment/customer-service-environment.component';
import { MarkingSchemeL3Component } from '../marking-scheme-l3/marking-scheme-l3.component';
import { CourseEvaluationFormComponent } from '../course-evaluation-form/course-evaluation-form.component';
import { RailLayout2FeedbackComponent } from '../rail-layout2-feedback/rail-layout2-feedback.component';
import { AssessmentPlanLevel3Component } from '../assessment-plan-level3/assessment-plan-level3.component';
import { EvidenceReferenceComponent } from '../evidence-reference/evidence-reference.component';
import { EvidenceReferencePtComponent } from '../evidence-reference-pt/evidence-reference-pt.component';
import { EvidenceReferenceL5ManagementComponent } from '../evidence-reference-l5-management/evidence-reference-l5-management.component';
import { AssessmentPlanAndRecordAchievementComponent } from '../assessment-plan-and-record-achievement/assessment-plan-and-record-achievement.component';
import { CasestudyMarkSchemeComponent } from '../casestudy-mark-scheme/casestudy-mark-scheme.component';
import { PatientConsentFormComponent } from '../patient-consent-form/patient-consent-form.component';
import { ChecklistComponent } from '../checklist/checklist.component';
import { Unit6ObservationCriteriaComponent } from '../unit6-observation-criteria/unit6-observation-criteria.component';
import { CaseStudyDelayComponent } from '../case-study-delay/case-study-delay.component';
import { AssessmentPlanGymComponent } from '../assessment-plan-gym/assessment-plan-gym.component';
import { AssessmentChecklistComponent } from '../assessment-checklist/assessment-checklist.component';
import { FeedbackAndMarkingComponent } from '../feedback-and-marking/feedback-and-marking.component';
// import { AddEvidenceModalComponent } from '../evidences/add-evidence-modal/add-evidence-modal.component';

// IMPORT COURSE LAYOUT COMPONENTS
import { MasterRailOneComponent } from '../../courses-layouts/master-rail-one/master-rail-one.component';
import { MasterRailsTwoComponent } from '../../courses-layouts/master-rails-two/master-rails-two.component';
import { ConstructionL1Component } from '../../courses-layouts/construction-l1/construction-l1.component';
import { CustomerServiceComponent } from '../../courses-layouts/customer-service/customer-service.component';
import { PDECourseComponent } from '../../courses-layouts/pde-course/pde-course.component';
import { DiplomaLevel3Component } from '../../courses-layouts/diploma-level3/diploma-level3.component';
import { DoorSupervisionComponent } from '../../courses-layouts/door-supervision/door-supervision.component';
import { SecurityOfficerComponent } from '../../courses-layouts/security-officer/security-officer.component';
import { ExerciseReferralComponent } from '../../courses-layouts/exercise-referral/exercise-referral.component';
import { RailEngineeringTechnicianComponent } from '../../courses-layouts/rail-engineering-technician/rail-engineering-technician.component';
import { CourseSignaturePadComponent } from '../course-signature-pad/course-signature-pad.component';
import { Angular2SignaturepadModule } from 'angular2-signaturepad';


@NgModule({
  declarations: [
    MainPortfolioComponent,
    AddSessionModalComponent,
    SessionsComponent,
    EvidencesComponent,
    // AddEvidenceModalComponent,
    PortfolioStatusComponent,
    ConfirmStatusComponent,
    PortfolioAssessmentPlanComponent,
    PerformanceAssessmentPlanComponent,
    AssessmentPlanComponent,
    AchievementSummarySheetComponent,
    EalMasterPortfolioComponent,
    MasterRailL2Form1Component,
    ObservationTableComponent,
    LearnerVideoObservationComponent,
    SpecimenSignatureComponent,
    InfoNContactComponent,
    PdePolicyComponent,
    CustomerServiceEnvironmentComponent,
    MarkingSchemeL3Component,
    CourseEvaluationFormComponent,
    RailLayout2FeedbackComponent,
    AssessmentPlanLevel3Component,
    EvidenceReferenceComponent,
    EvidenceReferencePtComponent,
    EvidenceReferenceL5ManagementComponent,
    AssessmentPlanAndRecordAchievementComponent,
    CasestudyMarkSchemeComponent,
    PatientConsentFormComponent,
    ChecklistComponent,
    Unit6ObservationCriteriaComponent,
    CaseStudyDelayComponent,
    AssessmentPlanGymComponent,
    AssessmentChecklistComponent,
    FeedbackAndMarkingComponent,


    // COURSE LAYOUT COMPONENTS IMPORT
    MasterRailOneComponent,
    MasterRailsTwoComponent,
    ConstructionL1Component,
    CustomerServiceComponent,
    PDECourseComponent,
    DiplomaLevel3Component,
    DoorSupervisionComponent,
    SecurityOfficerComponent,
    ExerciseReferralComponent,
    RailEngineeringTechnicianComponent,
    CourseSignaturePadComponent
  ],
  entryComponents: [
    ConfirmStatusComponent,
    CourseSignaturePadComponent
    // AddEvidenceModalComponent
  ],
  exports: [
    AddSessionModalComponent,
    SessionsComponent,
    EvidencesComponent,
    // AddEvidenceModalComponent,
    PortfolioStatusComponent,
    ConfirmStatusComponent,
    PortfolioAssessmentPlanComponent,
    PerformanceAssessmentPlanComponent,
    AssessmentPlanComponent,
    AchievementSummarySheetComponent,
    EalMasterPortfolioComponent,
    MasterRailL2Form1Component,
    ObservationTableComponent,
    LearnerVideoObservationComponent,
    SpecimenSignatureComponent,
    InfoNContactComponent,
    PdePolicyComponent,
    CustomerServiceEnvironmentComponent,
    MarkingSchemeL3Component,
    CourseEvaluationFormComponent,
    RailLayout2FeedbackComponent,
    AssessmentPlanLevel3Component,
    EvidenceReferenceComponent,
    EvidenceReferencePtComponent,
    EvidenceReferenceL5ManagementComponent,
    AssessmentPlanAndRecordAchievementComponent,
    CasestudyMarkSchemeComponent,
    PatientConsentFormComponent,
    ChecklistComponent,
    Unit6ObservationCriteriaComponent,
    CaseStudyDelayComponent,
    AssessmentPlanGymComponent,
    AssessmentChecklistComponent,
    FeedbackAndMarkingComponent,


    // COURSE LAYOUT COMPONENTS IMPORT
    MasterRailOneComponent,
    MasterRailsTwoComponent,
    ConstructionL1Component,
    CustomerServiceComponent,
    PDECourseComponent,
    DiplomaLevel3Component,
    DoorSupervisionComponent,
    SecurityOfficerComponent,
    ExerciseReferralComponent,
    RailEngineeringTechnicianComponent
  ],
  imports: [
    CommonModule,
    MainPortfolioRoutingModule,
    SharedModule,
    MaterialsModule,
    Angular2SignaturepadModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MainPortfolioModule { }
